export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const SET_NOTIFICATION_BANNER = "SET_NOTIFICATION_BANNER";
export const SET_NOTIFICATION_USER_READS = "SET_NOTIFICATION_USER_READS";
export const ADD_NOTIFICATION_USER_READ = "ADD_NOTIFICATION_USER_READ";
export const UPDATE_MARK_READ_NOTIFICATIONS = 'UPDATE_MARK_READ_NOTIFICATIONS';
export const UPDATE_PUSH_NOTIFICATION_USERACCESS = "UPDATE_PUSH_NOTIFICATION_USERACCESS";
export const REFRESH_NOTIFICATION = "REFRESH_NOTIFICATION";
export const FETCH_NOTIFICATION = "FETCH_NOTIFICATION";
export const FINISH_GET_NOTIFICATIONS = "FINISH_GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const NOTIFICATIONS_PAGE_READ = "NOTIFICATIONS_PAGE_READ"
